import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadBudgetaryPositions = async () => {
  let response = await Axois.get('/budgetary-positions').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadBudgetaryPosition = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/accounts');
        const responseData = await requests.data;
        return {accounts: responseData, position: {}};
      
      default:
        let response = await Axois.get('/budgetary-positions/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return [];
    }
  }catch (err) {
    console.log(err);
  }
}



const useBudgetaryPositionAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/budgetary-positions', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('position_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/budgetary-positions/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('position_response', {status: 'draft', seo: data.seo});
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useBudgetaryPositionAPI;